export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "producer_inspector": {
            "producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
            "crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo de cultivo"])},
            "inspector": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspector"])}
          }
        }
      }
    }
  })
}